import Hero from './components/Hero';
import ProofBar from './components/ProofBar';
import PlatformCapabilities from './components/PlatformCapabilities';
import IndustryImpact from './components/IndustryImpact';
import WhyGeofleet from './components/WhyGeofleet';
import IntegrationsHub from './components/IntegrationsHub';
import LifecycleStrip from './components/LifecycleStrip';
import LiteTeaser from './components/LiteTeaser';
import PricingTeaser from './components/PricingTeaser';
import HomeFAQ from './components/HomeFAQ';
import DemoCTA from './components/DemoCTA';
import SEO, { organizationJsonLd, websiteJsonLd, softwareApplicationJsonLd } from '../../components/SEO';

export default function HomePage() {
  return (
    <>
      <SEO
        title="Delivery Management Software with AI Dispatch Agents & Copilot"
        description="AI agents that plan, dispatch, track and prove every delivery. Geofleet matches each order to a driver in seconds, tracks every stop live, captures proof of delivery and reconciles cash, with a Copilot that works within your permissions. Plans from $49 a month for 3 drivers."
        jsonLd={[organizationJsonLd, websiteJsonLd, softwareApplicationJsonLd()]}
      />
      {/* 1–2: Promise + proof */}
      <Hero />
      <ProofBar />
      {/* 3–4: Product — the capabilities showcase, then one order through the lifecycle */}
      <PlatformCapabilities />
      <LifecycleStrip />
      <LiteTeaser />
      {/* 5–8: Fit — industry proof, why Geofleet, stack, price */}
      <IndustryImpact />
      <WhyGeofleet />
      <IntegrationsHub />
      <PricingTeaser />
      {/* 9: Decision support + close */}
      <HomeFAQ />
      <DemoCTA />
    </>
  );
}
